// Pageviews are not collected; flip to show them again
export const pageviewsEnabled = false

// Without the pageviews card the clicks and conversions live cards share the row
export const liveCardClass = pageviewsEnabled ? 'flex-2-5' : 'flex-1-2'

export const ignoreWorstNetworkUuids = [
  '2819e3d5-84bd-4db0-b55c-28b61af9ae33', // Heylink Inbound
  '4b4b3f71-6cee-40d0-9210-3b43062d5b27', // Linkbux
  '70bc39e3-fddb-45af-a4f7-e1e6a0bda5be', // Admedia
  '85b0eff4-38e4-431e-9e1e-062cc32d7c7e', // Bol.com
  '9e83d754-5b6f-4c67-b459-07e792884d82', // Sovrn
  'a1fd6c4f-c2e0-46e5-a309-9c28ae513e7b', // Amazon [custom ØS]
  'c9629182-3f4a-4cd7-a564-68a7919d4a97', // Pricerunner
  'd205cfb3-bd00-42dc-9606-fab308d62c2d', // Amazon
  '08dc6fe4-36db-4afe-96be-f3f7e32d7dd9', // Belboon
  'c426cbd5-6838-4487-bc74-a1a4fef42a19', // Ebay
]

export const ignoreHighLowNetworkUuids = [
  '2819e3d5-84bd-4db0-b55c-28b61af9ae33',
]
